module.exports = __webpack_public_path__ + "img/12-4.9265dae6.jpg";